import React, { useContext } from "react";
import Input from "../../shared/InputElements/Checkbox";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";
import { useIntl } from "react-intl";
import ToolTip from "../../shared/ToolTip/ToolTip";

  
const InputIncludeCharger = () => {
  const userPrefs = useContext(UserPrefsContext);
  const included = userPrefs.get("includeChargerCosts");
  const intl = useIntl();


    return (
      <div className="includeContainer">
        <Input
          id="include-charger-filter"
          value={included}
          label={
            intl.formatMessage
              ? intl.formatMessage({
                  id: 'evs.includeCharger',
                  defaultMessage: 'Include charger costs',
                })
              : 'Include charger costs'
          }
          handler={(e) => {
            userPrefs.set({ includeChargerCosts: e.target.checked });
          }}
        />
        <ToolTip
          message={
            intl.formatMessage
              ? intl.formatMessage({
                  id: 'evs.includeChargerTooltip',
                  defaultMessage:
                    'Include $1,800 to cover purchase and installation costs of a level 2 home charger',
                })
              : 'Include $1,800 to cover purchase and installation costs of a level 2 home charger'
          }
          id="incude-charger-tooltip"
        />
      </div>
    );
}

export default InputIncludeCharger;